module.exports = __webpack_public_path__ + "static/media/undraw_bike_ride_7xit.8539201c.svg";